import { useLazyStandardsFetch } from "./useLazyStandardsFetch";

export { useLazyStandardsFetch };
